import type { Application } from '@domain/entities';
import type { IApplicationRepository } from '@domain/repositories';

export class ToggleApplicationStatusUseCase {
  constructor(private readonly applicationRepository: IApplicationRepository) {}

  async execute(application: Application): Promise<Application> {
    return application.status === 'ACTIVE'
      ? this.applicationRepository.deactivate(application.id)
      : this.applicationRepository.activate(application.id);
  }
}
